import React from 'react'

function Home() {
    return (
        <div className="flex w-full flex-col items-center p-10">
            <h1 className="mb-5 text-black text-[36px] font-semibold">Main Component</h1>
            <p className="mb-3">My country’s name is Bangladesh. Bangladesh is a very small country
                huge population. It is a medium-developed country in South Asia. We have a very good and
                progressing economy. It has an area of 147,570 square kilometers. But it has a population of
                164 million. That is huge than the area.</p>
            <p className="mb-3">But it is still a very beautiful and peaceful country.
                People of Bangladesh are so friendly with each other. This country has a glorious history of
                independence. We got independence from Pakistan in 1971 after nine mothers’ blood-shedding war.
                More than 3 million Bangladeshi sacrificed their life in that genocide.</p>
            <p className="mb-3">But still, we were able to
                get our independence. After independence, the newly born country faced lots of hard times and
                struggles. But it rises very well. Now Bangladesh is one of the best countries to live in South Asia.
                There are so many beautiful spots to see in this country.</p>
        </div>
    )
}

export default Home
